import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, switchMap, take } from 'rxjs/operators';
import { StorageMap } from '@ngx-pwa/local-storage';

import { AngularFireAuth } from '@angular/fire/auth';
import { LoginAccountServerResponseInterface, LoginAuthWithLanguage } from '@sk/sk-interfaces';
import { fromPromise } from 'rxjs/internal-compatibility';
import { DOCUMENT } from '@angular/common';
import firebase from 'firebase/app';


@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  private userResponse: LoginAccountServerResponseInterface;

  constructor(private fbAuthService: AngularFireAuth,
              private storage: StorageMap,
              @Inject(DOCUMENT) private document: Document,
              private httpClient: HttpClient) {
  }


  /**
   * Login Step one
   */
  loginStepOne(email: string, password: string): Observable<any> {
    return this.httpClient
      .post<LoginAccountServerResponseInterface>(environment.api_url + '/loginStep1', JSON.stringify({ email, password }))
      .pipe(
        take(1),
        switchMap(res => {
          this.userResponse = res;
          if (res.code === 1) {
            return this.fbAuthService.signInWithCustomToken(res.customToken);
          }
          return of(res);
        }),
        switchMap(res => {
          if (this.userResponse.code === 1) {
            console.log('Save local UserResponse', this.userResponse);
            const language = environment.language;
            const localAuth: LoginAuthWithLanguage = { language, ...this.userResponse };
            return this.storage.set('auth', localAuth);
          } else {
            console.log('Skip authorization. return accounts', res);
            return of(this.userResponse);
          }
        }),
        map(() => {
          return this.userResponse;
        })
      );
  }


  /**
   * Login Step two
   */
  loginStepTwo(email: string, password: string, organizationId: string): Observable<LoginAccountServerResponseInterface> {
    return this.httpClient
      .post<LoginAccountServerResponseInterface>(environment.api_url + '/loginStep2', JSON.stringify({
        email,
        password,
        organizationId
      }))
      .pipe(
        take(1),
        switchMap(res => {
          this.userResponse = res;
          return this.fbAuthService.signInWithCustomToken(res.customToken);
        }),
        switchMap(() => this.storage.set('auth', this.userResponse)),
        map(() => {
          return this.userResponse;
        })
      );
  }


  /**
   *
   * @param email
   */
  sendResetEmail(email: string) {
    return fromPromise(this.fbAuthService.sendPasswordResetEmail(email));
  }



  getAuthorization$(): Observable<boolean> {
    let user: firebase.User = null;
    return this.fbAuthService.authState
      .pipe(
        switchMap(authUser => {
          // If we have a User check for AUTH
          if (authUser) {
            user = authUser;
            return this.storage.get('auth');
          }
          // Else return null and make sure IndexDB is cleared
          this.storage.clear().subscribe();
          return of(null);
        }),
        map((res: LoginAuthWithLanguage) => {
          // if User and User locally found
          if (res && res.uid === user.uid) {
            return true;
          } else {
            this.storage.clear().subscribe();
            this.fbAuthService.signOut().then();
            return false;
          }
        })
      );
  }


  getCurrentAuth(): Observable<LoginAuthWithLanguage> {
    return this.storage.get('auth')
      .pipe(
        take(1),
        map(res => {
          if (res) {
            const user = res as LoginAuthWithLanguage;
            return user;
          }
          return null;
        })
      );
    ;
  }


  resetPassword(email: string): Observable<void> {
    return fromPromise(this.fbAuthService.sendPasswordResetEmail(email));
  }


}
